import context, { Constants } from '@truckdown/systems';
import { defineComponent, computed } from 'vue';

interface IProps {
    section: string;
}

const getComputed = function (props: IProps) {
    return {
        header: computed(() => {
            if (props.section == 'favorites') {
                return 'Continue to upload your internal vendors';
            }
            else if (props.section == 'vendors') {
                return 'Activate your fleet features';
            }
            else if (props.section == 'setup') {
                if (context.isInRole(Constants.Roles.FleetUserRole)) {
                    return "Your account is activated";
                } else if (context.settings['fleet_trial']) {
                    return 'Contact us to activate your account';
                } else {
                    return 'Activate fleet features on your account - 3 months free';
                }
            }

            return 'Continue to favorites';
        }),
        paragraph: computed(() => {
            if (props.section == 'favorites') {
                return 'Please allow a few minutes for your preferred networks to syncronize in our system.  Once you have selected all of your preferred dealer networks, the next step is to upload your internal vendors.';
            }
            else if (props.section == 'vendors') {
                return 'Once we receive your uploaded file, we will provide you updates on our progress on matching them to our vendor list for you.';
            }
            else if (props.section == 'setup') {
                if (context.isInRole(Constants.Roles.FleetUserRole)) {
                    return "Verify your billing address and complete your set-up.";
                } else if (context.settings['fleet_trial']) {
                    return 'Your account already had a fleet trial activated.  Please contact us to enable the fleet features permanently.';
                } else {
                    return 'Provide your address and we will activate fleet features on your account for free.';
                }
            }
            return 'Once you have added your whole team, continue to set up your favorites.';
        }),
        actionLabel: computed(() => {
            if (props.section == 'setup') {
                if (context.isInRole(Constants.Roles.FleetUserRole)) {
                    return "Complete";
                } else if (context.settings['fleet_trial']) {
                    return "Contact us";
                } else {
                    return "Activate";
                }
            }
            return "Continue";
        })
    };
}

const getMethods = function (ctx: any) {
    return {
        triggerContinue: function () {
            ctx.emit('complete-step');
        }
    };
}

export default defineComponent({
    props: {
        section: {
            type: String,
            required: true
        }
    },
    name: "fleet-setup-step-summary",
    emits: ['complete-step'],
    components: {
    },
    setup: function (props: IProps, ctx: any) {
        const computed = getComputed(props);
        const methods = getMethods(ctx);

        return {
            ...computed,
            ...methods
        };
    }
});